import ArtistInvite from '../../components/ArtistInvite';

export const ARTIST_NAME = "bookbridge";
export const GROUP_ID = "f333e9cc-a9cc-4121-bb62-3856b249a5fc";
export const GROUP_NAME = "bookbridge community";
export const DESCRIPTION = `Join the private chat with ${ARTIST_NAME}`;
export const IMAGE = "https://uvxtacwciwpyrlvgakpm.supabase.co/storage/v1/object/public/public/bookbridge.jpg?t=2023-11-14T13%3A54%3A32.003Z";

const Bookbridge = () => {
  return <ArtistInvite
    title={GROUP_NAME}
    description={DESCRIPTION}
    metaImage={IMAGE}
    artistName={ARTIST_NAME}
    artistImage={IMAGE}
    messageBubbles={[
      "Hi",
      'hier ist dein "limited-edition-collectible" - nur für Besucher der Bücherschau.',
      "Trage deine E-Mail hier ein, um zum Group Chat zu gelangen"
    ]}
    mintPath='/bookbridge/mint'
    personal={false}
  />;
}


export default Bookbridge;